module.exports = __webpack_public_path__ + "static/media/ชวด.643c97b3.jpg";